<template>
  <div class="max-w-lg mx-auto py-16 px-4 text-center">
    <div class="flex justify-center mb-6">
      <div class="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
        <CheckIcon class="w-8 h-8 text-green-600" />
      </div>
    </div>

    <h2 class="text-2xl font-bold mb-4">Merci, votre choix est enregistré</h2>

    <p class="text-gray-600 mb-6">
      Vous avez accepté les nouvelles conditions de votre contrat. Votre couverture se poursuit sans interruption.
    </p>

    <div class="border rounded-lg p-4 mb-8">
      <p class="text-primary text-sm">
        Un email de confirmation vous a été envoyé avec le récapitulatif de vos nouvelles conditions.
      </p>
    </div>

    <PrimaryButton @click="$emit('close')">RETOUR À MON ESPACE</PrimaryButton>
  </div>
</template>

<script>
import { PrimaryButton } from "@estaly/ui";
import { CheckIcon } from "@heroicons/vue/solid";

export default {
  components: { PrimaryButton, CheckIcon },

  emits: ["close"],
};
</script>
